import React, { useState } from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';
import InputField from './InputField';

const PasswordInput = ({ id, name, label, value, onChange }) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <InputField
        type={passwordVisible ? 'text' : 'password'}
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={onChange}
        outline="true"
        style={{ flexGrow: 1 }} // Allow input to take up available space
      />
      <MDBIcon
        size='sm'
        icon={passwordVisible ? 'eye-slash' : 'eye'}
        onClick={togglePasswordVisibility}
        style={{
          marginLeft: '-30px',
          cursor: 'pointer',
          zIndex: '999',
        }}
      />
    </div>
  );
};

export default PasswordInput;
